/* ============================================================
   Earth Energy — Pure Bovine Colostrum PDP interactions
   Gallery, FLAVOR selector, pack options, subscribe toggle,
   accordions, sticky CTA, real Add-to-Cart (variant + plan).
   Flavor switches which variant ID is used; prices come LIVE
   from data-* attributes rendered by Liquid.
   ============================================================ */
(function(){
  function init(root){
    if(!root || root.dataset.eeInit === '1') return;
    root.dataset.eeInit = '1';

    /* ---------- Gallery ---------- */
    var slides = root.querySelectorAll('.gallery-main .ph');
    var thumbs = root.querySelectorAll('.thumb');
    function showSlide(i){
      slides.forEach(function(s){ s.classList.toggle('active', +s.dataset.slide === i); });
      thumbs.forEach(function(t){ t.classList.toggle('active', +t.dataset.thumb === i); });
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ showSlide(+t.dataset.thumb); }); });

    /* ---------- State ---------- */
    var state = { flavor: 'unflav', type: 'onetime' };
    var options    = root.querySelectorAll('.option');
    var flavorBtns = root.querySelectorAll('[data-flavor]');
    var typeBtns   = root.querySelectorAll('[data-type]');
    var subNote    = root.querySelector('.sub-note');
    var atcButtons = root.querySelectorAll('.js-atc');
    var sticky     = document.querySelector('.ee-pdp-sticky');
    var stickyPrice= sticky ? sticky.querySelector('.st-price') : null;
    var finalPrice = root.querySelector('.js-final-price');
    var finalSub   = root.querySelector('.js-final-sub');

    function activeOption(){ return root.querySelector('.option.active') || root.querySelector('.option'); }

    function selection(){
      var opt = activeOption();
      if(!opt) return null;
      var variant = state.flavor === 'choc' ? opt.dataset.variantChoc : opt.dataset.variantUnflav;
      var hasSub  = state.type === 'subscribe' && opt.dataset.moneySub;
      return {
        opt: opt,
        variant: variant || '',
        plan: opt.dataset.plan || '',
        isSub: !!hasSub,
        money: hasSub ? opt.dataset.moneySub : opt.dataset.moneyOnetime,
        label: opt.dataset.label || '',
        flavorLabel: state.flavor === 'choc' ? 'Chocolate' : 'Unflavored'
      };
    }

    function render(){
      var s = selection();
      if(!s) return;
      var priceLabel = s.isSub ? s.money + '/delivery' : s.money;
      atcButtons.forEach(function(btn){
        var el = btn.querySelector('.atc-price');
        if(el) el.textContent = priceLabel;
      });
      if(stickyPrice) stickyPrice.textContent = (s.label.split(' · ')[0]) + ' · ' + s.money;
      if(finalPrice) finalPrice.textContent = s.money;
      if(finalSub) finalSub.textContent = s.flavorLabel + ' · ' + s.label + (s.isSub ? ' · Subscribe & Save' : '');
      if(subNote){
        subNote.classList.toggle('show', s.isSub);
        var planEl = subNote.querySelector('.js-plan-name');
        if(planEl && s.opt.dataset.planName) planEl.textContent = s.opt.dataset.planName;
      }
    }

    options.forEach(function(opt){
      opt.addEventListener('click', function(){
        options.forEach(function(o){ o.classList.remove('active'); });
        opt.classList.add('active');
        render();
      });
    });

    flavorBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        flavorBtns.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        state.flavor = btn.dataset.flavor;
        render();
      });
    });

    typeBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        typeBtns.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        state.type = btn.dataset.type;
        render();
      });
    });

    /* ---------- Real Add to Cart ---------- */
    function addToCart(btn){
      var s = selection();
      if(!s) return;
      if(!s.variant){
        var o0 = btn.innerHTML; btn.textContent = 'Added ✓';
        setTimeout(function(){ btn.innerHTML = o0; render(); }, 1400); return;
      }
      var item = { id: s.variant, quantity: 1 };
      if(s.isSub && s.plan){ item.selling_plan = s.plan; }
      var orig = btn.innerHTML;
      btn.disabled = true; btn.dataset.busy = '1'; btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
      .then(function(){ btn.textContent = 'Added ✓'; window.location.href = '/cart'; })
      .catch(function(err){
        btn.disabled = false; btn.removeAttribute('data-busy');
        btn.textContent = (err && err.description) ? err.description : (btn.dataset.cartError || 'Could not add to cart.');
        setTimeout(function(){ btn.innerHTML = orig; render(); }, 2600);
      });
    }
    atcButtons.forEach(function(btn){ btn.addEventListener('click', function(){ if(btn.dataset.busy !== '1') addToCart(btn); }); });

    /* ---------- Accordions ---------- */
    root.querySelectorAll('.ing-list .ing').forEach(function(ing){
      var h = ing.querySelector('.ing-head');
      h && h.addEventListener('click', function(){ var o = ing.classList.toggle('open'); var b = ing.querySelector('.ing-body'); b.style.maxHeight = o ? b.scrollHeight + 'px' : 0; });
    });
    root.querySelectorAll('.faq-list .faq').forEach(function(faq){
      var q = faq.querySelector('.faq-q');
      q && q.addEventListener('click', function(){ var o = faq.classList.toggle('open'); var a = faq.querySelector('.faq-a'); a.style.maxHeight = o ? a.scrollHeight + 'px' : 0; });
    });
    root.querySelectorAll('.js-scroll-buy').forEach(function(btn){
      btn.addEventListener('click', function(){ var buy = root.querySelector('#ee-buy'); buy && buy.scrollIntoView({ behavior: 'smooth' }); });
    });

    /* ---------- Supplement Facts flavor toggle ---------- */
    var factsBtns = root.querySelectorAll('[data-facts]');
    var factsImgs = root.querySelectorAll('.facts-img');
    factsBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        factsBtns.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var f = btn.dataset.facts;
        factsImgs.forEach(function(im){ im.classList.toggle('active', im.dataset.factsImg === f); });
      });
    });

    /* ---------- Sticky CTA ---------- */
    if(sticky){
      var hero = root.querySelector('#ee-buy');
      window.addEventListener('scroll', function(){
        if(!hero) return;
        var hb = hero.getBoundingClientRect().bottom;
        var nf = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 620);
        sticky.classList.toggle('show', hb < 0 && !nf);
      }, { passive: true });
    }

    render();
  }
  function boot(){ document.querySelectorAll('.ee-pdp').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
